import { useEffect, useState } from 'react';
import { api } from '../api/client.js';

/** Resolves the season/week the app should open on. */
export function useCurrentWeek() {
  const [state, setState] = useState({ season: null, week: null, loading: true, error: null });

  useEffect(() => {
    let cancelled = false;

    api
      .currentWeek()
      .then((result) => {
        if (!cancelled) {
          setState({ season: result.seasonYear, week: result.weekNumber, loading: false, error: null });
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setState({ season: null, week: null, loading: false, error: err.message });
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
